import React from 'react'
import { SearchDropdown, HighlightedText } from '@ui'
import { UseBuildingTypesHook } from './hooks/useBuildingTypes'
import { NavigateFn } from '@reach/router'
import useBuildingTypeSearch from './hooks/useBuildingTypesSearch'
import track from '@track'

export default function BuildingTypeSearch({
  hook,
  navigate,
}: {
  hook: UseBuildingTypesHook
  navigate?: NavigateFn
}) {
  const { run, items, query, loading } = useBuildingTypeSearch()
  return (
    <SearchDropdown
      width={'300px'}
      search={{ run, items, query, loading }}
      onSelect={(buildingType) => {
        hook.search(buildingType.displayName)
        track.buildingTypes({
          eventName: track.Event.SEARCH_RESULT_CLICK,
        })
      }}
      renderItem={(buildingType) => (
        <HighlightedText text={buildingType.displayName} query={query} />
      )}
      queryTable={(string) => hook.search(string)}
    />
  )
}
